import React from 'react';
import ReactModal from 'react-modal';
import { BaseModal } from './BaseModal';
import { useWarnMessage } from '../../common/hooks/useWarn';

export interface ModalProps extends Omit<ReactModal.Props, 'style'> {
  className?: string;
  /**
   * Обработчик клика на кнопку закрытия
   */
  onCloseClick?: () => void;
  /**
   * Открытое состояние
   */
  isOpen: boolean;
  /**
   * Контент
   */
  children?: React.ReactNode;
  /**
   * Произвольные стили модального окна
   */
  style?: React.CSSProperties;
}

const defaultStyles = {};

export function Modal({
  isOpen = false,
  onCloseClick,
  children,
  className,
  style,
  ...props
}: ModalProps) {
  const { shouldCloseOnOverlayClick, shouldCloseOnEsc, onRequestClose } = props;
  const hasRequestClose = onRequestClose || onCloseClick;
  const shouldWarn =
    (shouldCloseOnOverlayClick || shouldCloseOnEsc) && !hasRequestClose;
  useWarnMessage(
    `Для работы 'shouldCloseOnOverlayClick' или 'shouldCloseOnEsc' необходимо передать проп 'onRequestClose' или 'onCloseClick'`,
    !!shouldWarn,
    Modal
  );
  const libProps: any = { defaultStyles };
  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      className={'hse-ModalOverlay__content'}
      overlayClassName={'hse-ModalOverlay'}
      onRequestClose={onCloseClick}
      {...libProps}
      {...props}
    >
      <BaseModal
        className={className}
        style={style}
        onCloseClick={onCloseClick}
      >
        {children}
      </BaseModal>
    </ReactModal>
  );
}
